import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { Meta, Title } from "@angular/platform-browser";
import storage from 'local-storage-fallback';

import { Globals } from '../../Globals'

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

  	model: any = {};
    loading = false;
    token = null;
    error = '';

    constructor(public globals: Globals, private meta: Meta,private title: Title, private router: Router,private authenticationService: AuthenticationService) { 
       
    }
  
  	ngOnInit() {
        this.title.setTitle("Login");
        // reset login status
       
         if(this.authenticationService.isLoged() == true){
             this.router.navigate(['/']);
        }else{
           
        }
    }

    login() {
      this.loading = true;
      this.authenticationService.login(this.model.username, this.model.password)
      .subscribe(result => {
        if(result.data){
          storage.setItem('token', result.data.user.token);
          this.globals.user = result.data.user;
          this.globals.token = result.data.user.token;
          this.globals.wid = result.data.user.wid;
          this.globals.apiImageEndpoint = result.data.user.cdn;
          this.router.navigate(['/']);
        } else {
          this.error = result.errors.email.message;
          this.loading = false; 
        }
      }, error => {
        this.error = 'Username or password is incorrect';
        this.loading = false;
      });
    }
    logout() {
      this.authenticationService.logout();
    }
}
